export default () => {
  const systemIsDark = process.client && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches

  const configs = useRuntimeConfig().public
  const isDark = useState('isDark', () => true)
  if (configs.withDarkMode) {
    isDark.value = Boolean(systemIsDark)
  } else {
    isDark.value = false
  }
  const bodyDark = computed(() => isDark.value ? 'dark' : '')
  const arcoDark = computed(() => isDark.value ? { 'arco-theme': 'dark' } : {})
  const toggleDark = () => {
    isDark.value = !isDark.value
  }

  const checkIsMobile = () => {
    if (!process.server) {
      return window.innerWidth <= 768
    }
    return true
  }

  return {
    isDark,
    bodyDark,
    arcoDark,
    toggleDark,
    checkIsMobile,
  }
}
